import React from 'react';

/**
 * Accessible on/off switch.
 * @param {{checked: boolean, onChange: (next: boolean) => void, disabled?: boolean, label: string}} props
 */
export default function Toggle({ checked, onChange, disabled = false, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`inline-flex items-center gap-2 text-xs font-semibold disabled:opacity-50 ${checked ? 'text-civix-purpleSoft' : 'text-white/50'}`}
    >
      <span className={`w-9 h-5 rounded-full flex items-center px-0.5 transition ${checked ? 'bg-civix-purple justify-end' : 'bg-white/15 justify-start'}`}>
        <span className="w-4 h-4 rounded-full bg-white block" />
      </span>
      {checked ? 'ON' : 'OFF'}
    </button>
  );
}
